export default __webpack_public_path__ + "static/media/landing_page_content.3286ebe8.png";